import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';

interface FormGuardModalProps {
    isOpen: boolean;
    onStayOnPage: () => void;
    onLeaveWithoutSaving: () => void;
    onSaveAndContinue: () => void;
    isProcessing: boolean;
    hasSaveAction: boolean;
}

const FormGuardModal: React.FC<FormGuardModalProps> = ({
    isOpen,
    onStayOnPage,
    onLeaveWithoutSaving,
    onSaveAndContinue,
    isProcessing,
    hasSaveAction
}) => {
    return (
        <Modal 
            isOpen={isOpen} 
            toggle={onStayOnPage}
            backdrop="static"
            keyboard={false}
            centered
            className="form-guard-modal"
        >
            <ModalHeader toggle={onStayOnPage} className="border-0 pb-0">
                <div className="d-flex align-items-center">
                    <span className="me-2 fs-4">⚠️</span>
                    <span>Alterações não salvas</span>
                </div>
            </ModalHeader>
            
            <ModalBody className="pt-0">
                <p className="mb-3 text-muted">
                    Você fez alterações no formulário que ainda não foram salvas. 
                    O que deseja fazer?
                </p>
                <div className="alert alert-warning d-flex align-items-center py-2 px-3 mb-0" style={{ fontSize: '0.875rem', backgroundColor: '#fff3cd', borderColor: '#ffeaa7', color: '#856404' }}>
                    <span className="me-2">💡</span>
                    <small>
                        <strong>Dica:</strong> Use <kbd>Ctrl+S</kbd> para salvar rapidamente suas alterações.
                    </small>
                </div>
            </ModalBody>
            
            <ModalFooter className="border-0 pt-0">
                <div className="d-flex gap-2 w-100 justify-content-end">
                    <Button
                        color="secondary"
                        outline
                        onClick={onStayOnPage}
                        disabled={isProcessing}
                        size="sm"
                    >
                        Continuar editando
                    </Button>
                    
                    <Button
                        color="danger"
                        outline
                        onClick={onLeaveWithoutSaving}
                        disabled={isProcessing}
                        size="sm"
                    >
                        Sair sem salvar
                    </Button>
                    
                    {hasSaveAction && (
                        <Button
                            color="primary"
                            onClick={onSaveAndContinue}
                            disabled={isProcessing}
                            size="sm"
                            className="d-flex align-items-center"
                        >
                            {isProcessing && (
                                <Spinner size="sm" className="me-2" />
                            )}
                            Salvar e continuar
                        </Button>
                    )}
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default FormGuardModal;